<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import MyTcTickets from '../dashboards/widgets/MyTcTickets.vue';
import MyTcIncidentReports from '../dashboards/widgets/MyTcIncidentReports.vue';

// import Profile from "@/components/widgets/profile";
// import Earning from "@/components/widgets/earning";
// import Stat from "@/components/widgets/stat";
// import Transaction from "@/components/widgets/transaction";
// import Emailsent from "@/components/widgets/emailsent";
// import SocialSource from "@/components/widgets/social-source";
// import Activity from "@/components/widgets/activity";
// import SellingProduct from "@/components/widgets/selling-product";

// import UnresolvedSlaBreaches from "./widgets/UnresolvedSlaBreaches";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "MyTC",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // UnresolvedSlaBreaches,
    Layout,
    PageHeader,
    MyTcTickets,
    MyTcIncidentReports,
    // Profile,
    // Stat,
    // Transaction,
    // Earning,
    // Emailsent,
    // SocialSource,
    // Activity,
    // SellingProduct,
  },
  data() {
    return {
      title: "MyTC",
      items: [
        // {
        //     text: "Dashboard",
        //     href: "#",
        // },
        // {
        //     text: "Default",
        //     active: true,
        // },
      ]
    };
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
<!--    <PageHeader :title="title" :items="items"/>-->
    <div class="row">
      <div class="col-xl-12">
        <my-tc-tickets></my-tc-tickets>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xl-12">
        <my-tc-incident-reports></my-tc-incident-reports>
      </div>
    </div>
  </Layout>
</template>
